// extracted by mini-css-extract-plugin
export default {"container":"_2tKhK","small":"_2T_uB","medium":"_3wh_Y","footerPost":"_35Obg","search":"_349z5","hashtags":"_3_Wta"};